import React, {
  DetailedHTMLProps,
  ImgHTMLAttributes,
  useMemo,
  useState
} from 'react';

import {
  getCroppedAvatar,
  getDefaultAvatar
} from 'common/tools/images/avatars';
import { removeScheme } from 'common/tools/network/url';

type AvatarProps = {
  alt?: string;
  className?: string;
  fix?: boolean;
  size?: number;
  src?: string;
};

const Avatar = ({
  alt = '',
  src = '',
  size = 60,
  className = '',
  fix = false
}: AvatarProps) => {
  const [imgSrc, setImgSrc] = useState<string | undefined>(src);

  const resizedPicture = useMemo(
    () => removeScheme(getCroppedAvatar(imgSrc || getDefaultAvatar(), size)),
    [imgSrc, size]
  );

  const extraProps: DetailedHTMLProps<
    ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  > = {
    alt: alt || 'avatar',
    className: className
  };

  // For reasons of responsive, it is sometimes necessary to leave the image in free dimension.
  if (fix) {
    extraProps.width = size;
    extraProps.height = size;
  }

  return (
    <img
      src={resizedPicture}
      onError={() => {
        setImgSrc(getDefaultAvatar());
      }}
      {...extraProps}
    />
  );
};

export default Avatar;
